import { Tooltip } from "antd";
import LeftsideBars from "./leftsidebar";
import { useSelector } from "react-redux";
import MainMenus from '../../common/menus';
import CallDialPadMain from "./callsDialPad";
import RecInner from "./callsWidgets/recInner";
import styles from "./scss/callsFrame.module.scss";
import React, { useEffect } from "react";
import CreateTask from "./callsWidgets/createTask";
import TopHeader from "../chat/chatsection/topheader";
import Transcript from "./callsWidgets/callsTranscript";
import CallsInnerTop from "./callsWidgets/callsInnerTop";
import CallsInnerLogs from "./callsWidgets/callsInnerLogs";
import VoiceMailInner from "./callsWidgets/voiceMailInner";
import ToastLeft from '../../shared/widgets/toastScreenleft';
import CallsAutomatedMints from "./callsWidgets/automatedMints";
import { initialStateModel, startaScreenModel, UserDetails } from "../../models/model";
import { max_Call_Window, toggleBtn } from "../../base/callService/common";
import NoCalls from "./leftsidebar/noCalls";
import callencryt from "../../styles/images/callencryptSm.svg"
// import DialConnecting from "./callsDialPad/numberconnecting";
// import CallMainWindow from "./callsDialPad/callMainWindow";
// import TransferCalls from "./callsDialPad/transfercalls";
// import ConferenceCalls from "./callsDialPad/conferencecall";
import { callMainPageInterface, updatedCallStore } from "../../models/callModel";
import ChatShareFile from "./callsWidgets/callsShareFile";
import DiallpadToast from "./callsDialPad/toastbottom";
import { expandArrowCalling, switchComponent } from "../../base/callService/store_mining";
import CallsEditShareTrans from "./callsWidgets/callsEditShareTrans";
import CreateDropDown from "../chat/leftsidebar/createdropdown";
import { getAllCounts } from "../../base/callService/callsApiService";
import InnerEncryption from "../../common/innerEncryption";
import { useHistory } from "react-router";
import { SocketChatService } from "../../base/socketChatService";
import { Cookie, Logout } from "../../base/utils";
import { unregister, initiateCall } from "../../base/callService/callService";
import { totalTabBatchcount, userInfo } from "../../base/socketChatService/utils";
//import { updateMeetingTotalBatch } from "../../base/meetingService/apiService";
import { Meetingnotifications } from "../videonotifications/Meetingnotifications";
import { handelMeetingNotification, storeAudioTranscript } from "../../base/socketChatService/newChat";
// import { style } from "wavesurfer.js/src/util";
// import URavatarGroupList from "../../shared/widgets/avatarGroupList";
// import { URAvatarGroup } from "../../shared/widgets/avatarGroup";
// import { closeCaption } from "../../context/reducer/closeCaption";
import { URCheckBox } from "../../shared/widgets/checkbox";
import { URInput } from "../../shared/widgets/input";
// import CallMainWindowTeam from "./callsDialPad/callMainWindowTeam";
// import { text } from "stream/consumers";
import DiallingWindow from "./callsDialPad/diallingWindow";
import CallRightBar from "./callsDialPad/callRightBar";
import store from "../../context/store/store";


type callState = { isDialBookActive: Boolean; }

const Call = () => {
  const history = useHistory();
  const { updatedCallList, toastReducer }: callMainPageInterface =
    useSelector((state: callMainPageInterface) => state);
  const { startingScreenLoader }: startaScreenModel =
    useSelector((state: initialStateModel) => state.startingScreenReducer);
  const { callReducer }: initialStateModel = useSelector((state: initialStateModel) => state);
  const initalState: any = useSelector((state: any) => state.serverDisconnectReducer);
  let { logs, callHistory, isLogLoading } = callReducer;
  // const [getCallState, setCallState] = useState<callState>({
  //   isDialBookActive: false
  // });

  const { showError }: updatedCallStore
    = useSelector((state: updatedCallStore) => state);

  useEffect(() => {
 
    let chromeCount:any = totalTabBatchcount();
    document.title= chromeCount > 0 ?"Worktual Web Application ("+ chromeCount +")" : "Worktual Web Application";
    switchComponent('callList');
    let loggeduser: UserDetails = store.getState().loginReducer.userdetails || [];
    const socketservice = new SocketChatService(loggeduser.sip_login_id,loggeduser.domain_id);
    console.log(socketservice,"socketservice====");
    
    socketservice.getActiveGroupCalls();
    getAllCounts();
    // let teamsCallNumber:any = localStorage.getItem('call_number');
   
    // if(teamsCallNumber) {
    //   setTimeout(() => {
    //     initiateCall(teamsCallNumber,'audio');
    //   }, 8000);
    // }
    
    return () => {
      max_Call_Window();
    };
  }, []);

  useEffect(() => {
    if (initalState?.serverDisconnect) {
    try {
     // Logout().then(() => {
        const chatService = new SocketChatService(userInfo().fromID, userInfo().domainId);
        if (chatService.socketConnection) {
          chatService.socketConnection.closeConnection();
          
        }
        chatService.destroy();
        chatService.eventEmit = null;
        chatService.socketConnection = null;
        Cookie.clear();
        localStorage.clear();
        sessionStorage.clear();
        SocketChatService._instance = null;
        unregister();
        history.push("/login");
        history.replace("/login")
     // });
      } catch(error:any){
        console.log(error,"error")
      }
    }
  }, [initalState?.serverDisconnect])

  useEffect(() => {
    if (toastReducer.meetingNotify.title !== undefined) {
      //console.log('toastReducer.meetingNotify -- > -- ', toastReducer.meetingNotify);
      //openNotification('topRight', toastReducer.meetingNotify);
      Meetingnotifications('topRight', toastReducer.meetingNotify, history);
      handelMeetingNotification({});
    }
  }, [toastReducer.meetingNotify])

  let emptyPage: boolean = (((logs.length === 0) && (!isLogLoading && callHistory.length === 0)) ? true : false);
  let isdialpadWin: Boolean = (updatedCallList.callDetails && updatedCallList.callDetails.length > 0
    && !updatedCallList.minimizedWindow) ? false : true;

  // const setDialBook = () => {
  //   setCallState({
  //     ...getCallState, isDialBookActive: !getCallState.isDialBookActive
  //   });
  // }

  // const menu = (
  //   <Menu>
  //     <Menu.Item>Share Voicemail</Menu.Item>
  //     {/* <Menu.Item onClick={showModal11}>Share</Menu.Item> */}
  //     <Menu.Item>Delete</Menu.Item>
  //     {/* <Menu.Item>Download</Menu.Item> */}
  //   </Menu>
  // );

  const outPutLangSelection = (
    <>
      <div className={styles.autoTranslateLangs}>
        <span className={styles.topsecTxtTitle}>Record Spoken language</span>
        <div className={styles.searchBox}><URInput placeHolder='Search' className='searchBoxlanglist' /></div>
        <ul className={`scroller ${styles.langList}`}>
          <li className={styles.selected}><span className="icon_tick"></span> Global English (en) - default</li>
          <li><span className="icon_tick"></span> Spanish (es)</li>
          <li><span className="icon_tick"></span> French (fr)</li>
          <li><span className="icon_tick"></span> Portuguese (pt)</li>
          <li><span className="icon_tick"></span> Japanese (ja)</li>
          <li><span className="icon_tick"></span> Korean (ko)</li>
          <li><span className="icon_tick"></span> Korean (ko)</li>
          <li><span className="icon_tick"></span> Korean (ko)</li>
          <li><span className="icon_tick"></span> Korean (ko)</li>
          <li><span className="icon_tick"></span> Korean (ko)</li>
        </ul>
        <div className={`customchecksize ${styles.bottomFooterSec}`}>
          <URCheckBox /><span className={styles.saveTxttop}>Save for future</span>
        </div>
      </div>
    </>
  );

  return (
    <>
      {(startingScreenLoader) && <InnerEncryption fromComponent={"Calls"} icon={callencryt} />}

      <div className={styles.mainframe}>
        <div className={styles.framemenu}>
          <MainMenus></MainMenus>
        </div>

        <div className={`${(updatedCallList.rightSideWindow === "transcript" && updatedCallList.isTranscriptionOnOff) ? `${styles.frameleftsidebar}` : `${styles.frameleftsidebar}`}`} >
          <div className={styles.mobilemenu}><span className="icon_close"></span></div>
          <LeftsideBars />
        </div>

        {(updatedCallList.rightSideWindow === "transcript" && updatedCallList.isWindowSlide && updatedCallList.isTranscriptionOnOff) &&
          <div className={`${styles.transarrow}`} onClick={expandArrowCalling}>
            <span className="icon_expandarrow"></span></div>
        }

        <div className={`${(updatedCallList.rightSideWindow === "transcript" && updatedCallList.isTranscriptionOnOff)
          ? `${styles.framemain} ${styles.transcriptmainframe}` : `${styles.framemain}`}`}>
          {/* <div className={`${styles.framemain} ${(updatedCallList.rightSideWindow === "transcript"
          && updatedCallList.isTranscriptionOnOff) ? `${styles.transcriptmainframe}` : ''}`}> */}
          <div className={styles.frameheader}>
            <div className={styles.mobilemenu}>Menus</div>
            <TopHeader></TopHeader>
            {/* {(updatedCallList.rightSideWindow === "transcript" &&
              updatedCallList.isWindowSlide && updatedCallList.isTranscriptionOnOff) &&
              <div className={styles.topbars}>
                <CreateDropDown></CreateDropDown>
              </div>
            } */}
          </div>
          { /*  left side window  */}
          {/* <div className={!updatedCallList.isWindowSlide ? `${styles.framemainsection}
        ${styles.framecolappse}`
            : updatedCallList.isCallFullScreen ? `${styles.framemainsection}
        ${styles.framecolappse} ` : updatedCallList.minimizedWindow ? `${styles.miniCallWinidow}`p
              : `${(updatedCallList.isWindowSlide && updatedCallList.rightSideWindow !== 'dialpad')
                ? `${styles.framemainsection} rightWindow` : `${styles.framemainsection}`}`}> */}

          <div className={!updatedCallList.isWindowSlide ? `${(updatedCallList.rightSideWindow === "participantList" )
            && styles.newteamcallmain} ${styles.framemainsection} rightWindow` :  `${styles.framemainsection} ${(updatedCallList.rightSideWindow === "transcript" ) ? styles.transcriptdiv : ""} 
             ${(updatedCallList.isCallFullScreen)&&styles.framecolappse} ${((updatedCallList.rightSideWindow === "participantList" || updatedCallList.rightSideWindow === "transcript") &&
            updatedCallList.centerWindow === "callWindow") && styles.newteamcallmain} ` }>


            {/* Team Call Code Stats */}
            {/* <div className={styles.mainteamcall}>
              <div className={styles.teamcallinner}>
                <div className={styles.topflex}>
                  <div className={styles.teamtoplayer}>
                    <URAvatarGroup className={`${'lefts size82 four'} ${styles.avatarname}`} profileInfo={<><span>A</span><span>B</span><span>C</span><span>4</span></>} />
                    <h3>UI Designing</h3>
                    <p className={styles.timelength}>01:23:22<span className={styles.hd}>HD</span><span className={styles.hold}>On Hold</span></p>
                    <CallMainWindowTeam></CallMainWindowTeam>
                  </div>
                </div>

                <div className={styles.teambottomlayer}>
                  <div className={styles.voiceMailOptions}>
                    <Tooltip placement="top" title="Mark as Unread"><div className={styles.readUNread}>
                      <div className={styles.unReaddot}></div>
                    </div></Tooltip>
                    <Tooltip placement="top" title="Automated Minutes ON"><div className={styles.autoMatedMinutes} >
                    </div></Tooltip>
                    <Tooltip placement="top" title="Transcribe ON"><div className={`${styles.transcribe} ${styles.selected}`}></div></Tooltip>
                    <Tooltip placement="top" title="Translation ON"><div className={styles.autoTranslate}>
                      <div className={`${styles.translateSec}`}>
                        <Dropdown overlay={outPutLangSelection} placement="bottomRight" trigger={['click']}>
                          <div className={styles.langSelSec}>
                            <span className="icon_down-arrow"><div className={styles.langTooltip}>Language</div></span>
                          </div>
                        </Dropdown>
                      </div>
                      <div className={styles.inputLang}>Korean</div>
                    </div></Tooltip>
                    <Tooltip placement="top" title="More">
                      <Dropdown overlay={menu} placement="bottomRight" trigger={['click']}>
                        <div className={styles.moreAction}></div>
                      </Dropdown>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div> */}
            {/* Team Call Code Ends Here */}


            {/* {(updatedCallList.centerWindow === "callWindow" && !updatedCallList.minimizedWindow) */}
             {(updatedCallList.centerWindow === "callWindow")
              && <DiallingWindow callDetail={updatedCallList.callDetails}></DiallingWindow>}


            {!isdialpadWin &&
              <>
                <div className={styles.newcall}>
                  <h3>New Call</h3>
                </div>
              </>
            }

            {/* {(!updatedCallList.isCallActive && !updatedCallList.callPlusIcon
              && updatedCallList.rightSideWindow !== 'transcript') &&
              <><Tooltip placement="left"
                title={!updatedCallList.isWindowSlide ? 'Click to expand' : 'Click to collapse'}>
                <div className={!updatedCallList.isWindowSlide ? `${styles.arrowsnav} ${styles.arrowchange}`
                  : `${styles.arrowsnav}`} onClick={() => toggleBtn(updatedCallList)}>
                  <span className="icon_Strokeleftarrow"></span></div>
              </Tooltip>
              </>
            } */}
             {(updatedCallList.isCallActive &&
              updatedCallList.rightSideWindow !== "transcript" && updatedCallList.rightSideWindow !== "summary") &&
              <Tooltip placement="left" title="Pop Out ">
                {updatedCallList.centerWindow !== "callWindow" ? "" : <span className={`${"icon_popin"} ${styles.popout}`} onClick={max_Call_Window}></span>}
              </Tooltip>
            }
            {/* {(updatedCallList.isCallActive && !updatedCallList.minimizedWindow &&
              updatedCallList.rightSideWindow !== "transcript" && updatedCallList.rightSideWindow !== "summary") &&
              <Tooltip placement="left" title="Pop Out1">
                <span className={`${"icon_popin"} ${styles.popout}`} onClick={max_Call_Window}></span>
              </Tooltip>
            } */}

            {/* {(!updatedCallList.isCallActive) ?
              (
                <><Tooltip placement="left"
                  title={!updatedCallList.isWindowSlide ? 'Click to collapse' : 'Click to expand'}>
                  <div className={!updatedCallList.isWindowSlide ? `${styles.arrowsnav} ${styles.arrowchange}`
                    : `${styles.arrowsnav}`} onClick={() => toggleBtn(updatedCallList)}>
                    <span className="icon_Strokeleftarrow"></span></div>
                </Tooltip></>
              )
              :
              (
                <>
                  {(!updatedCallList.minimizedWindow && updatedCallList.rightSideWindow !== "transcript" && updatedCallList.rightSideWindow !== "summary") &&
                  <Tooltip placement="left" title="Pop Out">
                    <span className={`${"icon_popin"} ${styles.popout}`} onClick={max_Call_Window}></span>
                  </Tooltip>
                  }
                </>
              )
            } */}


            <div className={styles.callmainsections}>
              {(updatedCallList.centerWindow !== "callWindow") &&
                <div className={`${styles.chatinnerframe} ${styles.calllogmains} lineTophide`}>
                  {(updatedCallList.leftSideWindow === "callList" && emptyPage) ?
                    <> <NoCalls /></>
                    :
                    (updatedCallList.leftSideWindow === "callList" && <>
                      <CallsInnerTop />
                      <CallsInnerLogs />
                    </>)
                  }
                  {updatedCallList.leftSideWindow === "voiceMail" && <VoiceMailInner />}
                  {updatedCallList.leftSideWindow === "recordList" && <RecInner />}
                </div>
              }
            </div>

            {/* <div className={styles.callmainsections}>
              {updatedCallList.isCallActive && !updatedCallList.minimizedWindow ?
                (
                  <div className={`${styles.chatinnerframe} lineTophide`}>
                    <div className={`${styles.maindialpadscalling}`}>
                      {conferenceDetails.isConference && !conferenceDetails.isNewCall ?
                        (<ConferenceCalls confDetail={conferenceDetails.list}
                          callDetail={updatedCallList.callDetails}></ConferenceCalls>)
                        :
                        (
                          <>
                            {updatedCallList.callDetails.length === 1 ?

                              !getCallState.isDialBookActive && (<DialConnecting callDetail={updatedCallList.callDetails}></DialConnecting>)
                              :
                              (
                                <TransferCalls updatedCallList={updatedCallList}
                                  confDetail={conferenceDetails}></TransferCalls>

                              )
                            }
                          </>
                        )
                      }
                      <CallMainWindow dialpadUI={setDialBook} />
                    </div>
                  </div>
                )
                :
                (
                  <div className={`${styles.chatinnerframe} ${styles.calllogmains} lineTophide`}>
                    {(updatedCallList.leftSideWindow === "callList" && emptyPage) ?
                      <> <NoCalls /></>
                      :
                      (updatedCallList.leftSideWindow === "callList" && <>
                        <CallsInnerTop />
                        <CallsInnerLogs />
                      </>)
                    }
                    {updatedCallList.leftSideWindow === "voiceMail" && <VoiceMailInner />}
                    {updatedCallList.leftSideWindow === "recordList" && <RecInner />}
                  </div>
                )
              }
            </div> */}

            {(showError.isToast && updatedCallList.isCallFullScreen)
              && <DiallpadToast showMsg={showError.message}></DiallpadToast>}
          </div>

          {/* ${updatedCallList.rightSideWindow === "participantList" && styles.newteamcallmain} */}
          { /*  Right side window  */}
          {/* {(updatedCallList.isWindowSlide && !updatedCallList.isCallFullScreen) && */}
          <div className={!updatedCallList.isWindowSlide ?
            `${styles.framerightsidebar} ${(updatedCallList.rightSideWindow === "participantList" &&
              updatedCallList.centerWindow === "callWindow") ? styles.newteamright : ((updatedCallList.rightSideWindow === "dialpad" && updatedCallList.minimizedWindow ) ? (updatedCallList.isCallActive?styles.framerightsidebar:styles.hideframerightsidebar) : styles.hideframerightsidebar) }`
            :(updatedCallList?.minimizedWindow && !updatedCallList?.callPlusIcon) ? `${styles.miniCallWinidow} ${styles.framerightsidebar} ${styles.newteamright}`
              : (updatedCallList.rightSideWindow === "participantList") ? `${styles.newteamright} ${styles.framerightsidebar}`
              :(updatedCallList.rightSideWindow === "transcript") ?  `${styles.framerightsidebar} ${styles.newteamright}` : `${styles.framerightsidebar}`}>

            {updatedCallList.rightSideWindow === "participantList" &&
              <CallRightBar />}


            {updatedCallList.rightSideWindow === "dialpad" && <CallDialPadMain />}



            {updatedCallList.rightSideWindow === "summary" && <CallsAutomatedMints />}


            {updatedCallList.rightSideWindow === "summaryEdit" && <CallsEditShareTrans />}
            {updatedCallList.rightSideWindow === "summaryShare" && <ChatShareFile />}
            {updatedCallList.rightSideWindow === "transcript" && <Transcript />}
            {updatedCallList.rightSideWindow === "createTask" && <CreateTask />}
          </div>


          
        </div>
      </div>


      {toastReducer.isLeftToast && <ToastLeft />}

      {/* <ActiveonMobilescreen /> */}

    </ >);
};


export default Call;